import React , {useRef} from "react";


export default function SignUp() {
  
  const emailRef = useRef('');
  
  const submitHandler = (event) => { 
    event.preventDefault();
    alert("FORM IS SUBMITTED!! with Email- "+(emailRef.current.value) );
  }


  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-10 mx-auto">
          <h1 className="text-center my-5">Fill in the details !!</h1>
          <div className="row">
            <div className="col-md-5 col-sm mx-auto">
              <form className="signup-form" onSubmit={submitHandler}>
                <div className="mb-3">
                  <label for="exampleInputEmail1" className="form-label">
                    Email address
                  </label>
                  <input
                  
                  ref={emailRef}
                  required
                    type="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp "
                  />
                  <div id="emailHelp" className="form-text">
                    We'll never share your email with anyone else.
                  </div>
                </div>
                <div className="mb-3">
                  <label for="exampleInputPassword1" className="form-label">
                    Password
                  </label>
                  <input
                  required
                    type="password"
                    className="form-control"
                    id="exampleInputPassword1 "
                  />
                </div>
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="exampleCheck1 "
                  />
                  <label className="form-check-label" for="exampleCheck1">
                    Check me out
                  </label>
                </div>
                <button type="submit" className="btn btn-primary submit-button">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
